/**
 * DEV-1082. Строки вкладки «Юниты» карточки проекта: таблица, фильтры,
 * модалка юнита, блоки. Подмешиваются поверх базовых локалей (locales/index.ts).
 */
export const dev1082Messages = {
  ru: {
    properties: {
      tabs: { overview: 'Обзор', units: 'Юниты', materials: 'Материалы', analytics: 'Аналитика' },
      units: {
        title: 'Юниты',
        addUnit: 'Юнит',
        importFromFile: 'Импорт из файла',
        manageBlocks: 'Блоки',
        loadError: 'Не удалось загрузить юниты',
        empty: 'Юниты не заведены',
        emptyHint: 'Добавьте юниты руками или загрузите прайс застройщика',
        emptyFiltered: 'Под фильтры не подошёл ни один юнит',
        summary: {
          total: 'Всего юнитов',
          available: 'Доступно',
          reserved: 'Бронь',
          sold: 'Продано',
          blocks: 'Блоков',
          minPrice: 'Мин. цена',
          noPrice: 'Нет цен',
        },
        filters: {
          block: 'Блок',
          status: 'Статус',
          rooms: 'Комнатность',
          floor: 'Этаж',
          all: 'Все',
          floorPlaceholder: 'Этаж',
          codePlaceholder: 'Код юнита…',
          reset: 'Сбросить',
          noBlock: 'Без блока',
          // DEV-1219: юниты, которых не было в последнем применённом прайсе.
          stale: 'Не обновлён последним импортом',
          staleHint:
            'Этих юнитов не было в последнем загруженном прайсе — скорее всего они проданы, но на витрине сайта всё ещё показываются. Проверьте список и поправьте статусы.',
        },
        table: {
          code: 'Код',
          block: 'Блок',
          floor: 'Этаж',
          rooms: 'Комнаты',
          area: 'Площадь, м²',
          direction: 'Направление',
          view: 'Вид',
          price: 'Цена',
          status: 'Статус',
        },
        statuses: {
          UNIT_STATUS_AVAILABLE: 'Доступен',
          UNIT_STATUS_RESERVED: 'Бронь',
          UNIT_STATUS_SOLD: 'Продан',
        },
        views: {
          UNIT_VIEW_CATEGORY_SEA: 'Море',
          UNIT_VIEW_CATEGORY_RIVER: 'Река',
          UNIT_VIEW_CATEGORY_LAKE: 'Озеро',
          UNIT_VIEW_CATEGORY_CITY: 'Город',
          UNIT_VIEW_CATEGORY_POOL: 'Бассейн',
          UNIT_VIEW_CATEGORY_GOLF: 'Гольф',
          UNIT_VIEW_CATEGORY_PARK: 'Парк',
          UNIT_VIEW_CATEGORY_MOUNTAIN: 'Горы',
          UNIT_VIEW_CATEGORY_COURTYARD: 'Внутренний двор',
          UNIT_VIEW_CATEGORY_INTERNAL: 'Внутренний вид',
        },
        handover: {
          HANDOVER_CONDITION_BARE_SHEL: 'Без отделки',
          HANDOVER_CONDITION_WARM_SHELL: 'Черновая отделка',
          HANDOVER_CONDITION_FULLY_FITTED: 'Базовая отделка',
          HANDOVER_CONDITION_FURNISHED: 'С мебелью',
          HANDOVER_CONDITION_TURNKEY: 'Под ключ',
        },
        sources: { UNIT_SOURCE_MANUAL: 'Заведён руками', UNIT_SOURCE_IMPORT: 'Из импорта' },
        form: {
          titleNew: 'Новый юнит',
          titleEdit: 'Юнит {code}',
          sectionMain: 'Основное',
          sectionArea: 'Площадь и вид',
          sectionPrice: 'Цена и статус',
          sectionRaw: 'Данные застройщика (сырые)',
          rawBadge: 'Служебное',
          rawHint: 'Значения из прайса как есть. В клиентские представления не идут.',
          code: 'Код юнита',
          codeHint: 'Уникален внутри проекта',
          codeRequired: 'Укажите код юнита',
          block: 'Блок',
          floor: 'Этаж',
          floorHint: 'Текстом: бывает «3A», «G»',
          rooms: 'Комнатность',
          objectType: 'Тип объекта',
          phase: 'Очередь / фаза',
          areaCarpet: 'Чистая (thông thủy), м²',
          areaBuiltUp: 'По стенам (tim tường), м²',
          direction: 'Направление балкона',
          directionHint: 'Свободный текст: импорт пишет сюда значение застройщика',
          viewCategory: 'Категория вида',
          price: 'Цена',
          currency: 'Валюта',
          priceHint: 'Цена для иностранца; пусто — цены нет',
          status: 'Статус',
          handoverCondition: 'Передача',
          layoutCode: 'Код планировки',
          statusRaw: 'Статус (исходный)',
          viewRaw: 'Вид (исходный)',
          notSet: 'Не задано',
          save: 'Сохранить',
          cancel: 'Отмена',
          delete: 'Удалить юнит',
          confirmDelete: 'Удалить юнит {code}?',
          created: 'Юнит добавлен',
          updated: 'Юнит сохранён',
          deleted: 'Юнит удалён',
          saveError: 'Не удалось сохранить юнит',
          deleteError: 'Не удалось удалить юнит',
        },
        blocks: {
          title: 'Блоки и башни',
          pageTitle: '{name} — блоки',
          backToProject: 'К карточке проекта',
          add: 'Блок',
          name: 'Название',
          floors: 'Этажей',
          handover: 'Передача',
          empty: 'Блоки не заведены',
          floorsShort: '{count} этажей',
          unitsShort: '{count} юнитов',
          handoverShort: 'передача {value}',
          autoCount: 'Число блоков в карточке проекта считается по фактическому списку.',
          nameRequired: 'Укажите название блока',
          confirmDelete: 'Удалить блок {name}? Юниты останутся у проекта без блока.',
          created: 'Блок добавлен',
          updated: 'Блок сохранён',
          deleted: 'Блок удалён',
          error: 'Не удалось сохранить блок',
          deleteError: 'Не удалось удалить блок',
          loadError: 'Не удалось загрузить блоки',
        },
      },
    },
  },
  en: {
    properties: {
      tabs: {
        overview: 'Overview',
        units: 'Units',
        materials: 'Materials',
        analytics: 'Analytics',
      },
      units: {
        title: 'Units',
        addUnit: 'Unit',
        importFromFile: 'Import from file',
        manageBlocks: 'Blocks',
        loadError: 'Failed to load units',
        empty: 'No units yet',
        emptyHint: 'Add units manually or import a developer price list',
        emptyFiltered: 'No units match the filters',
        summary: {
          total: 'Units total',
          available: 'Available',
          reserved: 'Reserved',
          sold: 'Sold',
          blocks: 'Blocks',
          minPrice: 'Min. price',
          noPrice: 'No prices',
        },
        filters: {
          block: 'Block',
          status: 'Status',
          rooms: 'Rooms',
          floor: 'Floor',
          all: 'All',
          floorPlaceholder: 'Floor',
          codePlaceholder: 'Unit code…',
          reset: 'Reset',
          noBlock: 'No block',
          stale: 'Not updated by the last import',
          staleHint:
            'These units were missing from the last uploaded price list — most likely sold, yet still shown on the website. Review the list and fix their statuses.',
        },
        table: {
          code: 'Code',
          block: 'Block',
          floor: 'Floor',
          rooms: 'Rooms',
          area: 'Area, m²',
          direction: 'Direction',
          view: 'View',
          price: 'Price',
          status: 'Status',
        },
        statuses: {
          UNIT_STATUS_AVAILABLE: 'Available',
          UNIT_STATUS_RESERVED: 'Reserved',
          UNIT_STATUS_SOLD: 'Sold',
        },
        views: {
          UNIT_VIEW_CATEGORY_SEA: 'Sea',
          UNIT_VIEW_CATEGORY_RIVER: 'River',
          UNIT_VIEW_CATEGORY_LAKE: 'Lake',
          UNIT_VIEW_CATEGORY_CITY: 'City',
          UNIT_VIEW_CATEGORY_POOL: 'Pool',
          UNIT_VIEW_CATEGORY_GOLF: 'Golf',
          UNIT_VIEW_CATEGORY_PARK: 'Park',
          UNIT_VIEW_CATEGORY_MOUNTAIN: 'Mountain',
          UNIT_VIEW_CATEGORY_COURTYARD: 'Courtyard',
          UNIT_VIEW_CATEGORY_INTERNAL: 'Internal',
        },
        handover: {
          HANDOVER_CONDITION_BARE_SHEL: 'Bare shell',
          HANDOVER_CONDITION_WARM_SHELL: 'Warm shell',
          HANDOVER_CONDITION_FULLY_FITTED: 'Fully fitted',
          HANDOVER_CONDITION_FURNISHED: 'Furnished',
          HANDOVER_CONDITION_TURNKEY: 'Turnkey',
        },
        sources: { UNIT_SOURCE_MANUAL: 'Added manually', UNIT_SOURCE_IMPORT: 'From import' },
        form: {
          titleNew: 'New unit',
          titleEdit: 'Unit {code}',
          sectionMain: 'General',
          sectionArea: 'Area and view',
          sectionPrice: 'Price and status',
          sectionRaw: 'Developer data (raw)',
          rawBadge: 'Internal',
          rawHint: 'Price-list values as is. Never used in client-facing views.',
          code: 'Unit code',
          codeHint: 'Unique within the project',
          codeRequired: 'Enter the unit code',
          block: 'Block',
          floor: 'Floor',
          floorHint: 'Text: can be “3A”, “G”',
          rooms: 'Rooms',
          objectType: 'Object type',
          phase: 'Phase',
          areaCarpet: 'Net (thông thủy), m²',
          areaBuiltUp: 'Built-up (tim tường), m²',
          direction: 'Balcony direction',
          directionHint: 'Free text: import stores the developer value here',
          viewCategory: 'View category',
          price: 'Price',
          currency: 'Currency',
          priceHint: 'Foreigner price; empty means no price',
          status: 'Status',
          handoverCondition: 'Handover',
          layoutCode: 'Layout code',
          statusRaw: 'Status (raw)',
          viewRaw: 'View (raw)',
          notSet: 'Not set',
          save: 'Save',
          cancel: 'Cancel',
          delete: 'Delete unit',
          confirmDelete: 'Delete unit {code}?',
          created: 'Unit added',
          updated: 'Unit saved',
          deleted: 'Unit deleted',
          saveError: 'Failed to save the unit',
          deleteError: 'Failed to delete the unit',
        },
        blocks: {
          title: 'Blocks and towers',
          pageTitle: '{name} — blocks',
          backToProject: 'Back to the project card',
          add: 'Block',
          name: 'Name',
          floors: 'Floors',
          handover: 'Handover',
          empty: 'No blocks yet',
          floorsShort: '{count} floors',
          unitsShort: '{count} units',
          handoverShort: 'handover {value}',
          autoCount: 'The block count on the project card follows the actual list.',
          nameRequired: 'Enter the block name',
          confirmDelete: 'Delete block {name}? Its units stay in the project without a block.',
          created: 'Block added',
          updated: 'Block saved',
          deleted: 'Block deleted',
          error: 'Failed to save the block',
          deleteError: 'Failed to delete the block',
          loadError: 'Failed to load blocks',
        },
      },
    },
  },
  vn: {
    properties: {
      tabs: {
        overview: 'Tổng quan',
        units: 'Căn hộ',
        materials: 'Tài liệu',
        analytics: 'Phân tích',
      },
      units: {
        title: 'Căn hộ',
        addUnit: 'Căn hộ',
        importFromFile: 'Nhập từ tệp',
        manageBlocks: 'Tòa / block',
        loadError: 'Không tải được danh sách căn hộ',
        empty: 'Chưa có căn hộ',
        emptyHint: 'Thêm căn hộ thủ công hoặc nhập bảng giá của chủ đầu tư',
        emptyFiltered: 'Không có căn hộ nào khớp bộ lọc',
        summary: {
          total: 'Tổng số căn',
          available: 'Còn hàng',
          reserved: 'Giữ chỗ',
          sold: 'Đã bán',
          blocks: 'Số tòa',
          minPrice: 'Giá thấp nhất',
          noPrice: 'Chưa có giá',
        },
        filters: {
          block: 'Tòa',
          status: 'Trạng thái',
          rooms: 'Số phòng ngủ',
          floor: 'Tầng',
          all: 'Tất cả',
          floorPlaceholder: 'Tầng',
          codePlaceholder: 'Mã căn…',
          reset: 'Đặt lại',
          noBlock: 'Không thuộc tòa',
          stale: 'Không được cập nhật ở lần nhập gần nhất',
          staleHint:
            'Những căn hộ này không có trong bảng giá tải lên gần nhất — nhiều khả năng đã bán, nhưng vẫn hiển thị trên website. Hãy kiểm tra và sửa trạng thái.',
        },
        table: {
          code: 'Mã căn',
          block: 'Tòa',
          floor: 'Tầng',
          rooms: 'Phòng ngủ',
          area: 'Diện tích, m²',
          direction: 'Hướng',
          view: 'View',
          price: 'Giá',
          status: 'Trạng thái',
        },
        statuses: {
          UNIT_STATUS_AVAILABLE: 'Còn hàng',
          UNIT_STATUS_RESERVED: 'Giữ chỗ',
          UNIT_STATUS_SOLD: 'Đã bán',
        },
        views: {
          UNIT_VIEW_CATEGORY_SEA: 'Biển',
          UNIT_VIEW_CATEGORY_RIVER: 'Sông',
          UNIT_VIEW_CATEGORY_LAKE: 'Hồ',
          UNIT_VIEW_CATEGORY_CITY: 'Thành phố',
          UNIT_VIEW_CATEGORY_POOL: 'Hồ bơi',
          UNIT_VIEW_CATEGORY_GOLF: 'Sân golf',
          UNIT_VIEW_CATEGORY_PARK: 'Công viên',
          UNIT_VIEW_CATEGORY_MOUNTAIN: 'Núi',
          UNIT_VIEW_CATEGORY_COURTYARD: 'Sân trong',
          UNIT_VIEW_CATEGORY_INTERNAL: 'Nội khu',
        },
        handover: {
          HANDOVER_CONDITION_BARE_SHEL: 'Bàn giao thô',
          HANDOVER_CONDITION_WARM_SHELL: 'Hoàn thiện cơ bản phần thô',
          HANDOVER_CONDITION_FULLY_FITTED: 'Hoàn thiện cơ bản',
          HANDOVER_CONDITION_FURNISHED: 'Full nội thất',
          HANDOVER_CONDITION_TURNKEY: 'Trọn gói',
        },
        sources: { UNIT_SOURCE_MANUAL: 'Nhập thủ công', UNIT_SOURCE_IMPORT: 'Từ bảng giá' },
        form: {
          titleNew: 'Căn hộ mới',
          titleEdit: 'Căn hộ {code}',
          sectionMain: 'Thông tin chung',
          sectionArea: 'Diện tích và view',
          sectionPrice: 'Giá và trạng thái',
          sectionRaw: 'Dữ liệu chủ đầu tư (gốc)',
          rawBadge: 'Nội bộ',
          rawHint: 'Giá trị gốc từ bảng giá. Không dùng cho khách hàng.',
          code: 'Mã căn hộ',
          codeHint: 'Duy nhất trong dự án',
          codeRequired: 'Nhập mã căn hộ',
          block: 'Tòa',
          floor: 'Tầng',
          floorHint: 'Dạng chữ: có thể là «3A», «G»',
          rooms: 'Số phòng ngủ',
          objectType: 'Loại hình',
          phase: 'Giai đoạn',
          areaCarpet: 'Thông thủy, m²',
          areaBuiltUp: 'Tim tường, m²',
          direction: 'Hướng ban công',
          directionHint: 'Văn bản tự do: nhập bảng giá lưu nguyên giá trị của chủ đầu tư',
          viewCategory: 'Loại view',
          price: 'Giá',
          currency: 'Tiền tệ',
          priceHint: 'Giá cho người nước ngoài; để trống nghĩa là chưa có giá',
          status: 'Trạng thái',
          handoverCondition: 'Bàn giao',
          layoutCode: 'Mã layout',
          statusRaw: 'Trạng thái (gốc)',
          viewRaw: 'View (gốc)',
          notSet: 'Chưa đặt',
          save: 'Lưu',
          cancel: 'Hủy',
          delete: 'Xóa căn hộ',
          confirmDelete: 'Xóa căn hộ {code}?',
          created: 'Đã thêm căn hộ',
          updated: 'Đã lưu căn hộ',
          deleted: 'Đã xóa căn hộ',
          saveError: 'Không lưu được căn hộ',
          deleteError: 'Không xóa được căn hộ',
        },
        blocks: {
          title: 'Tòa và block',
          pageTitle: '{name} — tòa và block',
          backToProject: 'Về trang dự án',
          add: 'Tòa',
          name: 'Tên',
          floors: 'Số tầng',
          handover: 'Bàn giao',
          empty: 'Chưa có tòa nào',
          floorsShort: '{count} tầng',
          unitsShort: '{count} căn',
          handoverShort: 'bàn giao {value}',
          autoCount: 'Số tòa trên thẻ dự án được tính theo danh sách thực tế.',
          nameRequired: 'Nhập tên tòa',
          confirmDelete: 'Xóa tòa {name}? Các căn hộ vẫn thuộc dự án nhưng không có tòa.',
          created: 'Đã thêm tòa',
          updated: 'Đã lưu tòa',
          deleted: 'Đã xóa tòa',
          error: 'Không lưu được tòa',
          deleteError: 'Không xóa được tòa',
          loadError: 'Không tải được danh sách tòa',
        },
      },
    },
  },
}
